interface Entry {
    key: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    optional: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Explode<T> = _Explode<T extends readonly any[] ? Record<string, T[number]> : T>;

type _Explode<T> = T extends object
    ? {
          [K in keyof T]-?: K extends string
              ? Explode<T[K]> extends infer E
                  ? E extends Entry
                      ? {
                            key: `${K}${E["key"] extends "" ? "" : ":"}${E["key"]}`;
                            value: E["value"];
                            optional: E["key"] extends ""
                                ? // eslint-disable-next-line @typescript-eslint/ban-types
                                  {} extends Pick<T, K>
                                    ? true
                                    : false
                                : E["optional"];
                        }
                      : never
                  : never
              : never;
      }[keyof T]
    : { key: ""; value: T; optional: false };

type Collapse<T extends Entry> = {
    [E in Extract<T, { optional: false }> as E["key"]]: E["value"];
} & Partial<{ [E in Extract<T, { optional: true }> as E["key"]]: E["value"] }> extends infer O
    ? { [K in keyof O]: O[K] }
    : never;

export type Flatten<T> = Collapse<Explode<T>>;

export function ensureVariant<T>(v: unknown, variants: T[], fallback?: T): T {
    if (variants.includes(v as T)) {
        return v as T;
    }
    if (fallback) {
        return fallback;
    }
    // TODO_FUTURE: maybe fix warning and remove lint.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new Error(`Invalid variant: ${v}`);
}

export type NoUndefined<T> = T extends undefined ? never : T;

export function notNull<T>(v: T | null): T | undefined {
    return v ?? undefined;
}

export type NotNullable<T> = {
    [P in keyof T]: null extends T[P] ? Exclude<T[P], null> | undefined : T[P];
};

export function nullToUndefined<T extends object>(v: T): NotNullable<T> {
    const res = v as NotNullable<T>;
    for (const k in v) {
        const val = res[k];
        if (val === null) {
            (res[k] as unknown) = undefined;
        }
    }
    return res;
}
